import { render } from "./localizedTextArea.vue?vue&type=template&id=20b4b310&scoped=true&ts=true"
import script from "./localizedTextArea.vue?vue&type=script&lang=ts"
export * from "./localizedTextArea.vue?vue&type=script&lang=ts"

import "./localizedTextArea.vue?vue&type=style&index=0&id=20b4b310&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b4b310"]])

export default __exports__